import React from 'react';
import {useTranslation} from "react-i18next";

function SearchBar({ value, handleChange, autofocus }){
    const { t } = useTranslation();
  return (
      <div className="c-search_bar">
        <span className="c-search_bar-icon"></span>
        <input className="search-bar" type="text" placeholder={t('Recherche')}
        value={value}
        onChange={handleChange}
        autoFocus={autofocus === true ? true : false}
        autoComplete="off"
        />

      </div>
  );
}

export default SearchBar;
